/**
 * Guardie di rotta.
 *
 * Nascondere una voce di menù non è una misura di sicurezza: il vincolo «le
 * categorie le sceglie solo il super admin» vive nell'autorizzazione degli
 * endpoint (§3 del documento di progettazione, CONVENTIONS §5). Queste guardie
 * servono a **non mostrare all'utente pagine che l'API rifiuterebbe**, ed e' una
 * questione di qualita' dell'interfaccia, non di protezione.
 */

import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAutenticazione } from "./contesto";
import { Avviso, InCaricamento } from "../components/primitive";

/** Consente il passaggio solo a sessione aperta; altrimenti porta all'accesso. */
export function RottaProtetta() {
  const { utente, inAvvio } = useAutenticazione();
  const posizione = useLocation();

  if (inAvvio) return <InCaricamento etichetta="Ripristino della sessione…" />;
  if (!utente) return <Navigate to="/accesso" replace state={{ da: posizione.pathname }} />;
  return <Outlet />;
}

/** Consente il passaggio al solo super admin. */
export function RottaSuperAdmin() {
  const { eSuperAdmin } = useAutenticazione();

  if (!eSuperAdmin) {
    return (
      <div className="pila">
        <Avviso tono="critico" titolo="Sezione riservata">
          Questa sezione e' riservata al ruolo Super Admin. Se ritiene di doverne disporre, si
          rivolga all'amministratore del sistema.
        </Avviso>
      </div>
    );
  }
  return <Outlet />;
}
